import React from 'react';
import { ProductPageDocumentsState } from 'modules/aftermarket';
import { List, IconButton, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Document } from '@trnsact/trnsact-shared-types';
import { S3_BUCKET_NAME } from 'config';

interface Props {
  canWrite: boolean;
  documents: ProductPageDocumentsState;
  setDocuments: (documents: ProductPageDocumentsState) => void;
}

export const DocumentsList = ({ canWrite, documents, setDocuments }: Props) => {
  const handleDeleteFile = (file: File | Document) => {
    file instanceof File
      ? setDocuments({ ...documents, documentsToAdd: documents.documentsToAdd.filter(f => f !== file) })
      : setDocuments({
          ...documents,
          initialDocuments: documents.initialDocuments.filter(d => d !== file),
          documentsToRemove: [...documents.documentsToRemove, file],
        });
  };

  const handleDownloadFile = (file: File | Document) => {
    const downloadFile = (file: File) => {
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      URL.revokeObjectURL(url);
    };

    file instanceof File ? downloadFile(file) : window.open(file.source!);
  };

  return (
    <List>
      {[...documents.initialDocuments, ...documents.documentsToAdd].map(document => (
        <ListItem
          secondaryAction={
            canWrite && (
              <>
                <IconButton>
                  <DownloadIcon color="primary" onClick={() => handleDownloadFile(document)} />
                </IconButton>
                <IconButton>
                  <DeleteOutlineIcon onClick={() => handleDeleteFile(document)} color="error" />
                </IconButton>
              </>
            )
          }
        >
          <ListItemIcon>
            <InsertDriveFileIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={document instanceof File ? document.name : document.docName} />
        </ListItem>
      ))}
    </List>
  );
};
